export const ROOT = 'imageViewer';
export const SETTINGS_IMAGE_PREVIEW = 'imagePreview';
export const SETTINGS_CAPTION_INPUT = 'imageSettingsCaptionInput';
export const SETTINGS_ALT_INPUT_TEXT = 'imageSettingsAltInput';
export const SETTINGS_DISABLE_EXPAND_TOGGLE = 'imageSettingsDisableExpandToggle';
export const SETTINGS_DISABLE_DOWNLOAD_TOGGLE = 'imageSettingsDisableDownloadToggle';
export const SETTINGS_SPOILER_TOGGLE = 'imageSettingsSpoilerToggle';
